<template lang="pug">
GenericCard.actionDetail(size='50')
  .d-flex.flex-column.px-4.py-4
    .text-large แก้ไขข้อมูล
    .d-flex.pt-4
      EditableAvatar(
        :src='user.imgSrc'
        @change='submitNewProfilePicture'
        :isLoading='isSubmitting'
      )
      //- img.rounded-circle(:src='user.imgSrc' height='96' width='96')

      .detail.ml-4.pl-3.flex-fill
        .text-large {{ user.name }}

        .d-flex.mt-2
          DataItem.flex-fill( title='รหัส' :value='user.code' )
          DataItem.flex-fill( title='เขต' :value='user.zone' )

  hr.w-100.my-0

  .d-flex.flex-column.px-4.py-4
    .text-large เปลี่ยนรหัสผ่าน

    .d-flex.mt-2
      DataItem.flex-fill( title='ชื่อบัญชีเข้าใช้งาน' :value='user.username' )
      DataItem.flex-fill( title='รหัสผ่าน' :value='password' )

    button.btn.btn-secondary.w-33.mt-4.mx-auto(
      @click='changePasswordBtnClicked'
      :class='{ "active" : changePasswordPanelVisible }'
    )
      | เปลี่ยนรหัส

  //- can't use template, since the 'd-flex' class is set,
  //- v-show wouldn't function properly
  div(v-show='changePasswordPanelVisible === true')
    .d-flex.flex-column.px-4.py-4.blue-gradient
      .d-flex.align-items-center
        .text-medium ชื่อบัญชี
        InputWithIconSlot.mb-2.ml-auto(
          placeholder='ระบุ' width='100%'
          v-model='username'
        )
          i.fa.fa-pen
      .d-flex.align-items-center
        .text-medium รหัสผ่านปัจจุบัน
        InputWithIconSlot.mb-2.ml-auto(
          placeholder='' width='100%' type='password'
          ref='currentPwd'
          v-model='oldPassword'
        )
          i.fa.fa-pen
      .d-flex.align-items-center
        .text-medium รหัสผ่านใหม่
        InputWithIconSlot.mb-2.ml-auto(
          placeholder='ระบุ..' width='100%' type='password'
          v-model='newPassword'
        )
          i.fa.fa-pen
      .text-small.text-right.red(v-if='newPassword !== null && !newPasswordLongEnough')
        | รหัสผ่านต้องมีความยาวมากกว่า 8 ตัวอักษร

      .d-flex.align-items-center
        .text-medium รหัสผ่านใหม่อีกครั้ง
        InputWithIconSlot.mb-2.ml-auto(
          placeholder='ระบุ..' width='100%' type='password'
          v-model='newPasswordConfirmation'
        )
          i.fa.fa-pen
        //- .text-medium.red
      .text-small.text-right.red(v-if='newPasswordConfirmation !== null && !confirmedNewPassword')
        | กรุณาใส่รหัสผ่านใหม่ให้ตรงกันทั้ง 2 ช่อง

      //- other errors
      template(v-if='errors && errors.length > 0')
        .alert.alert-danger.mt-4
          template(v-for='e in errors')
            .text-small.text-right.red
              | {{ e }}

      button.btn.btn-upa-secondary.w-25.mt-3.mx-auto(
        :disabled='!isFormDataValid || isSubmitting'
        @click='submitNewPassword'
      )
        template(v-if='isSubmitting')
          LoadingIndicator
        template(v-else)
          | บันทึก

</template>

<script>
export default {
  computed: {
    password() {
      return '********';
    },
    isFormDataValid() {
      return this.username
            && this.oldPassword
            && this.confirmedNewPassword && this.newPasswordLongEnough;
    },
    confirmedNewPassword() {
      if (this.newPassword === this.newPasswordConfirmation) {
        return this.newPassword;
      }
      return null;
    },
    newPasswordLongEnough() {
      return this.newPassword && this.newPassword.length >= 8;
    },
  },
  // props: {
  //   user: {
  //     default: {
  //       name: 'ณัฐพนธ์ เชาวนศิลป',
  //       code: '08594111',
  //       zone: 'NWE',

  //       username: '08594111',
  //     },
  //   },
  // },
  data: () => ({
    user: {},
    isLoading: false,
    isSubmitting: false,
    changePasswordPanelVisible: false,

    username: '',
    oldPassword: '',
    newPassword: null,
    newPasswordConfirmation: null,

    errors: {},
  }),
  async created() {
    this.loadUserInfo();
  },
  methods: {
    async loadUserInfo() {
      this.isLoading = true;

      // const res = await this.$api.user.current();
      const res = await this.$api.user.myProfile();
      if (res.status === 200) {
        this.user = res.data;
        this.username = this.user.username;
      }

      this.isLoading = false;
    },
    changePasswordBtnClicked() {
      this.changePasswordPanelVisible = !this.changePasswordPanelVisible;

      // for now.. just put the first password input box in focus
      setTimeout(() => {
        if (this.changePasswordPanelVisible) {
          this.$refs.currentPwd.$el.children[0].focus();
        }
      }, 100);
    },

    async submitNewPassword() {
      const {
        user,
        oldPassword,
        newPassword,
        newPasswordConfirmation,
      } = this;

      this.isSubmitting = true;
      try {
        const res = await this.$api.user.changePassword(
          user.username,
          oldPassword,
          newPassword,
          newPasswordConfirmation,
        );
        if (res.status === 200) {
          // this.user = res.data.data;
          console.log(res);
          alert('บันทึกข้อมูลแล้ว');

          // RESET EVERYTHING
          this.oldPassword = '';
          this.newPassword = '';
          this.newPasswordConfirmation = '';

          this.changePasswordPanelVisible = false;

          this.errors = [];
        }
      } catch (e) {
        console.log(JSON.stringify(e));
        if (e.response && e.response.data && e.response.data.errors) {
          // alert(JSON.stringify(e.response.data.errors));
          this.errors = e.response.data.errors;
        } else if (e.error) {
          this.errors = [`เกิดข้อผิดพลาด.. ${JSON.stringify(e.error)}`];
        } else {
          if (e.message === 'Request failed with status code 401') {
            e.message = 'รหัสผ่านเดิมไม่ถูกต้อง';
          }
          this.errors = [e.message];
        }
      }

      this.isSubmitting = false;
    },

    async submitNewProfilePicture(newImg) {
      this.isSubmitting = true;

      const formData = new FormData();
      if (newImg) {
        formData.append('avatar', newImg);
      }

      try {
        await this.$api.user.changeAvatar(formData);
        this.errors = [];
        this.$emit('submit');
      } catch (e) {
        alert(`ไม่สามารถเปลี่ยนรูปโปรไฟล์ได้ \n${e.message}`);
      }

      this.isSubmitting = false;
    },
  },
};
</script>

<style lang="scss">
// .edit-personal-info-panel {}
</style>
